import VideoTplLegacy from "../VideoTplLegacy";
import {
    customCommand, VideoBridgeGetFileInfo,
    VideoBridgeReadyStatusHasReady,
    VideoBridgeReadyStatusNotReady,
    VideoBridgeReportUrls
} from "../../../api";
import {
    callDeveloperClicked,
    callDeveloperDismissed,
    callDeveloperEndCardShowSuccess,
    callDeveloperPlayCompleted,
    callDeveloperShowFailed,
    callDeveloperShowSucccess
} from "../../../api/noticeDeveloperAPI";
import {
    onSubPlayTemplateViewCloseBtnClicked,
    onSubPlayTemplateViewLoad,
    onComponentReactDeveloperCallbackCLICKED,
    onComponentReactDeveloperCallbackDISMISSED,
    onComponentReactDeveloperCallbackENDCARDSHOWSUCCESS,
    onComponentReactDeveloperCallbackPLAYCOMPLETED,
    onComponentReactDeveloperCallbackPLAYFAILED,
    onComponentReactDeveloperCallbackPLAYSUCCESS
} from "../../../api/componentReactListener";
import {
    _isPad,
    _fnIsPortrait,
    _appendUrlParam,
    _logSuccess,
    _logError,
    _preloadResource
} from "../../../common/m_base/util";
import {checkCreateResOK, checkResOK} from "../../../api/apiUtil";
import BigTpl from "../BigTpl";

/**
 * mintegral SDK 大模板
 */
export default class BigTplChoseFromTwo extends BigTpl {

    constructor(...props) {
        super(...props)

        // 表明当前模板如果要成功加载, 至少需要多少个 campaign
        this.slotSize = 2
        // 用来存储当前用户选择的, 将要进行播放的子模板
        this.userSelectedChildTpl = null
        // 记录播放失败时尝试的次数, 和尝试次数上限
        this.attemptCount = 0
        this.attemptLimit = 1
        // 存储通过当前大模板创建的子模板索引列表
        this.childTplList = [
            {
                campaignId: undefined,
                tplInstanceId: undefined,
                isPageLoadFinished: undefined,
                isImageReady: undefined,
            },
            {
                campaignId: undefined,
                tplInstanceId: undefined,
                isPageLoadFinished: undefined,
                isImageReady: undefined,
            },
        ]

        // 以下为初始化时通过 SDK 获取到的上下文环境变量,
        this.campaignList = null
        this.sdkInfo = null
        this.unitId = null
        this.appSetting = null
        this.unitSetting = null
        this.sdkSetting = null
        this.device = null
        this.bigTemplateInstanceId = null
        this.rootViewInstanceId = null
        this.playVideoMute = null
    }

    async init({JsBridgeRes}) {
        super.init({JsBridgeRes})

        // 从 SDK 获取 campaign 列表, 和当前环境的上下文信息
        await this.initSDKContext()

        // 如果当前从 SDK 获取到的 campaign 数量满足模板渲染要求
        if (this.isCampaignReady()) {

            this.bindChildTplListWithCampaignList()

            // webviewshow 之前预加载广告相关的图片资源, 确保
            this.batchPreloadCampaignImageResource()

            this.videoTplLegacy = new VideoTplLegacy({MTG_SDKContext})

            // 批量创建并预加载 "播放模板" 视图 (Native)
            await this.batchCreateVideoTemplateLegacy()

            // 两个 type 模板实例创建成功之后, 批量添加模板 preload 的事件监听
            this.batchAddPreloadFinishEventListener()

            // preload URL
            await this.batchPreloadVideoTemplateLegacy()

        } else {
            console.warn('当前 campaign 不满足模板初始化条件, 请检查.', {campaignList: this.campaignList})
            VideoBridgeReadyStatusNotReady({
                errMessage: '当前 campaign 不满足模板初始化条件, 请检查',
                errDetail: `campaign length: ${this.campaignList && this.campaignList.length}, ready 状态: ${this.campaignList && this.campaignList.forEach && this.campaignList.forEach(item => item.isReady)}`
            })
        }
    }

    isCampaignReady() {
        let campaignReadyState
        let campaignList = this.campaignList
        let isCampaignLengthFulfilled = campaignList && campaignList.length === this.slotSize
        if (isCampaignLengthFulfilled) {
            let nscptConfig
            nscptConfig = this.getNscptConfig()

            // nscptConfig 为 0 的情况下, 任意一个 campaign 的 video 加载达到 rate 值(默认 100%), 就可以认为广告 ready
            // 所以在 nscptConfig=0 的情况下, 大模板首次加载通过 init 拿到的 offer 有可能只有一个 offer 为 ready 状态
            if (nscptConfig === 0) {
                campaignReadyState = campaignList.filter(item => item.isReady).length >= 1
            }
            // nscptConfig 为非 0 其他值的情况下, 都按默认 1 来处理, 这时就需要所有 campaign 的 video 加载达到 rate 值(默认 100%), 才可以认为广告 ready
            else {
                campaignReadyState = campaignList.filter(item => item.isReady).length === this.slotSize
            }
        }
        // 基础的 campaign 长度不符合二选一模板要求
        else {
            campaignReadyState = false
            console.warn('基础的 campaign 长度不符合二选一模板要求', {campaignList})
        }
        return campaignReadyState
    }

    getNscptConfig() {
        let nscptConfig
        let campaignList = this.campaignList
        if (campaignList && campaignList[0] && typeof campaignList[0].nscpt !== 'undefined') {
            nscptConfig = campaignList[0].nscpt
        } else {
            nscptConfig = 1
        }
        return nscptConfig;
    }

    updateSDKContext(key, value) {
        if (typeof key === 'undefined') {
            console.warn('更新 SDKContext 失败, 请传入有效的 key 值')
            return false
        }

        this[key] = value
        if (this.MTG_SDKContext) {
            this.MTG_SDKContext[key] = value
        }
        return this.MTG_SDKContext
    }

    /**
     * 渲染大模板的静态 UI 部分
     */
    renderPageStaticUI({readyCampaignList} = {}) {

        // 准备渲染页面所需的数据
        let dataForRender = {
            campaignList: this.formatCampaignList(readyCampaignList),
            isPad: _isPad(),
            isPortrait: _fnIsPortrait(),
        };
        console.log({dataForRender})

        // 渲染页面
        window.MTG_RENDER(dataForRender)
    }

    /**
     * 批量创建 type4 模板实例
     * @returns {Promise<void>}
     */
    async batchCreateVideoTemplateLegacy() {
        for (let i = 0; i < this.campaignList.length; i++) {
            let campaign = this.campaignList[i]
            await this.createVideoTemplateLegacy(campaign);
        }
    }

    async createVideoTemplateLegacy(campaign) {
        let createRes = await this.videoTplLegacy
            .create({campaign})
            .catch(err => {
                _logError('创建 Native 播放模板异常: ', {err})
                VideoBridgeReadyStatusNotReady({
                    errMessage: '创建 Native 播放模板异常',
                    errDetail: JSON.stringify(err || {})
                })
            })
        if (checkCreateResOK(createRes)) {
            _logSuccess('创建 Native 播放模板成功: ', {createRes})
            // 关联 campaign 和 原生组件
            let curChildTpl = this.getChildTplByCampaignId(campaign.id);
            curChildTpl.tplInstanceId = createRes.data.id
            curChildTpl.isPageLoadFinished = false
        } else {
            _logError('创建 Native 播放模板失败: ', {createRes})
        }
    }

    batchAddPreloadFinishEventListener() {
        for (let curTplItem of this.childTplList) {
            this.addPreloadFinishEventListener(curTplItem);
        }
    }

    addPreloadFinishEventListener(curTplItem) {
        let expectCmptId = curTplItem && curTplItem.tplInstanceId
        // preload finish 回调 401
        onSubPlayTemplateViewLoad({
            expectCmptId,
            cb: ({id, data} = {}) => {

                // 加载失败或超时
                if (data && data.result !== 1) {
                    let resultConf = {
                        1: '成功',
                        2: '失败',
                        3: '超时',
                    }
                    let errMessage = `当前模板加载${resultConf[data.result]}: `;
                    console.warn(errMessage, {id, data})
                    VideoBridgeReadyStatusNotReady({
                        errMessage,
                        errDetail: `当前实例 id: ${id}, 返回的 data: ${JSON.stringify(data)}`,
                    })
                    return false
                }

                // 加载成功
                this.updateCurChildTplState(curTplItem)
                console.warn('=-= -------------------- preload 成功, 当前 load 成功的模板实例为: ', {id, data})
                console.log('=-= 当前所有模板的 load 状态: ', this.childTplList)

                // 给当前模板添加 type 2 3 4 5 四种类型的开发者回调事件监听
                console.log('---------- 注册开发者回调监听 start ----------')
                // 在大模板中预先初始化开发者回调所需的 Handler
                this.registerDeveloperCallbackHandler({expectCmptId})
                console.log('---------- 注册开发者回调监听 end ----------')

                // 给当前模板添加关闭按钮回调
                console.log('---------- 注册用户点击关闭按钮监听 start ----------')
                this.registerEndCardCloseButtonHandler({expectCmptId});
                console.log('---------- 注册用户点击关闭按钮监听 end ----------')

                this.handleTplPreloadResult()
            }
        })
    }

    updateCurChildTplState(curTplItem) {
        curTplItem.isPageLoadFinished = true
        if (curTplItem.isPageLoadFinished && curTplItem.isImageReady) {
            let campaign = this.getCampaignByCampaignId(curTplItem.campaignId)
            campaign.isReady = true
        } else {
            console.warn('当前子模板实例预加载完成, 但大图 icon 资源暂时没有 ready, 请注意.', curTplItem)
        }
    }

    handleTplPreloadResult() {
        // 如果所有模板和大图 icon 都 preload 成功, 则执行下一步 (addSubView/回调 SDK ready)
        if (this.allTplPreloadFinished()) {

            console.warn('------------------------------ =-= 所有模板 preload 成功 ------------------------------')
            console.log(this.childTplList)

            console.log('---------- 上报 HasReady start ----------')
            // 检查所有模板和大图 icon 是否都已经 preload finished, 如果是则通知 SDK ready
            VideoBridgeReadyStatusHasReady()
            console.log('---------- 上报 HasReady end ----------')

        }
        // 如果至少有一个子模板和大图 icon preload 成功, 则根据 nscpt 的配置决定后续逻辑
        else if (this.atLeastOneTplPreloadFinished()) {
            // let readyCampaignList = this.getReadyCampaignList()
            if (this.getNscptConfig() === 0) {
                console.log('已经加载成功了一个模板, 不再等待剩余的模板, 直接成功', this.childTplList)
                VideoBridgeReadyStatusHasReady()

                // 开始创建剩余的模板实例
                this.startCreateOtherReadyCampaign()
            } else {
                console.log('已经加载成功了一个模板, 但由于 nscpt 为 1, 所以这里需要等待所有子模板加载成功', this.childTplList)
            }
        }
    }

    async batchPreloadVideoTemplateLegacy() {
        for (let curTplItem of this.childTplList) {
            await this.preloadVideoTemplateLegacy(curTplItem);
        }
    }

    async preloadVideoTemplateLegacy(curTplItem) {
        if (curTplItem.tplInstanceId) {
            console.log(curTplItem.campaignId, curTplItem.tplInstanceId, 'preload 调用开始: ', {curTplIndex: curTplItem})
            let preloadRes = await this.videoTplLegacy
                .preload({id: curTplItem && curTplItem.tplInstanceId})
                .catch(err => {
                    console.warn(curTplItem.campaignId, curTplItem.tplInstanceId, 'preload 异常', {err})
                    VideoBridgeReadyStatusNotReady({
                        errMessage: 'preload 异常',
                        errDetail: JSON.stringify({curTplItem, err})
                    })
                })
            if (checkResOK(preloadRes)) {
                console.log(curTplItem.campaignId, curTplItem.tplInstanceId, 'preload 调用成功----------', {
                    preloadRes,
                    curTplItem
                })
            } else {
                console.warn(curTplItem.campaignId, curTplItem.tplInstanceId, 'preload 调用失败', {
                    preloadRes,
                    curTplItem
                })
                VideoBridgeReadyStatusNotReady({
                    errMessage: 'preload 调用失败',
                    errDetail: JSON.stringify({curTplItem, preloadRes})
                })
            }
        } else {
            console.warn('当前子模板实例 id 不存在, 不再尝试 preload', curTplItem)
        }
    }

    /**
     * 监听 type4 广告 endcard 阶段, triggerCloseBtn 被触发时 SDK 发出的事件通知
     * 接到通知时, 由 H5 调用 SDK API 通知开发者 dismissed 回调, 之后无论回调成功失败超时, 都需要调用 API 关闭当前广告
     */
    registerEndCardCloseButtonHandler({expectCmptId}) {
        // 1. componentReact 402
        sessionStorage.setItem(`registerEndCardCloseButtonHandler-${expectCmptId}`, `${Date.now()}`)
        console.trace('|||||||||| 1. start - 注册用户点击关闭按钮监听: componentReact 402', {expectCmptId})
        onSubPlayTemplateViewCloseBtnClicked({
            expectCmptId,
            cb: async ({id, data}) => {

                debugger

                // 2. reactDeveloper type 6
                console.warn('|||||||||| 2. start - "用户点击关闭按钮事件" 被触发, 即将调用开发者 dismissed 回调: reactDeveloper type 6')
                // type 4 类型广告被关闭, 调用 SDK API 通知开发者 dismissed 回调: data.convert // 1/2(成功/失败)
                // PS: 安卓端需要在回调开发者关闭时解析 campaign.notice_url, 所以需要在 callDeveloperDismissed 时传递 campaign 给 SDK
                data.campaign = this.currentCampaign
                let developerCallbackResult = await callDeveloperDismissed({
                    unitId: this.unitId,
                    data
                })
                console.warn('|||||||||| 2. end - 调用开发者 dismissed 回调完成', {developerCallbackResult})

                // 3. operate 402
                console.warn('|||||||||| 3. start - 即将调用最终的 closeAd : operate 402')
                let closeResult = await this.videoTplLegacy.close({id})
                console.warn('|||||||||| 3. end - 调用最终的 closeAd 完成: operate 402')
            }
        })
        console.warn('|||||||||| 1. end - 注册用户点击关闭按钮监听: componentReact 402')
    }

    /**
     * 在收到特定 SDK 事件时通知 SDK 给开发者展示广告阶段的回调
     * 当前支持的开发者回调 type:
     *      1: showsuccess， // 开发者调用 show 成功
     *      2: showfailed (error)， // 开发者调用 show 失败
     *      3: playcompleted， // 视频播放完毕
     *      4: endcardshowsuccess， // endcard 成功展示
     *      5: clicked， // 通过点击 cta button 或其他方式触发的 install 时触发
     *      6: dismissed（boolean convert） // endcard 被关闭
     */
    registerDeveloperCallbackHandler({expectCmptId}) {
        console.warn('--------------- 在收到特定 SDK 事件时通知 SDK 给开发者展示广告阶段的回调')

        let unitId = this.unitId

        onComponentReactDeveloperCallbackPLAYSUCCESS({
            expectCmptId,
            cb: ({id, data}) => {
                // data.expired = this.getCampaignExpiredState()
                console.warn('onComponentReactDeveloperCallbackPLAYSUCCESS')
                // 注意: SDK 针对 "type 4 类型" 的原生视图了特殊定制,
                //  与老版本的 RewardVideo 在开发者回调方面有以下区别:
                //  1. 老版本的 RewardVideo 会在视频开始播放时同时上报 only_impression_url 和 impression_url (即 PV), 且会主动发 showsuccess
                //  2. 新版本 SDK 大模板流程中的 "type 4 类型" 在视图被展示且自动开始播放时只会上报 impression_url, 且不会主动发 showsuccess
                //  因为按照二选一模板的逻辑, showsuccess 开发者回调在大模板的 webviewshow 阶段就需要调用了,
                //  这里需要无视 SDK 发出的 showsuccess, 二选一模板在收到此类型 componentReact 时不作处理即可
                // // 大模板被展示时, 调用 SDK API 通知开发者 showsuccess 回调
                // callDeveloperShowSucccess({unitId, data})
            }
        })

        onComponentReactDeveloperCallbackPLAYFAILED({
            expectCmptId,
            cb: ({id, data}) => {
                data.expired = this.getCampaignExpiredState()
                // 收到 SDK 的播放失败事件时, 调用 SDK API 通知开发者 showerror 回调
                callDeveloperShowFailed({unitId, data}) /* data: {error: data.error} */
            }
        })

        onComponentReactDeveloperCallbackPLAYCOMPLETED({
            expectCmptId,
            cb: ({id, data}) => {
                data.expired = this.getCampaignExpiredState()
                // "type 4 类型" 广告播放完成时, 调用 SDK API 通知开发者 playcompleted 回调
                callDeveloperPlayCompleted({unitId, data})
            }
        })

        onComponentReactDeveloperCallbackENDCARDSHOWSUCCESS({
            expectCmptId,
            cb: ({id, data}) => {
                data.expired = this.getCampaignExpiredState()
                // endcard 展示成功时, 调用 SDK API 通知开发者 endcardshowsuccess 回调
                callDeveloperEndCardShowSuccess({unitId, data})
            }
        })

        onComponentReactDeveloperCallbackCLICKED({
            expectCmptId,
            cb: ({id, data}) => {
                data.expired = this.getCampaignExpiredState()
                // clicked 时, 调用 SDK API 通知开发者 clicked 回调
                callDeveloperClicked({unitId, data})
            }
        })

        onComponentReactDeveloperCallbackDISMISSED({
            expectCmptId,
            cb: ({id, data}) => {
                // data.expired = this.getCampaignExpiredState()
                // // type 4 类型广告被关闭, 调用 SDK API 通知开发者 dismissed 回调: data.convert // 1/2(成功/失败)
                // 二选一模板的关闭不再需要监听 SDK 发出的 "开发者回调事件", 而是在用户点击 endcard 阶段的关闭按钮时,
                //  直接调用开发者回调 "dismissed", 并在 SDK 返回成功时, 直接调用 Native 关闭方法 (operateComponent 402)
                // callDeveloperDismissed({unitId, data})
            }
        })
    }

    /**
     * 隐藏全屏 loading 提示
     */
    showPageLoading() {
        let DOMLoading = document.querySelector('.page-loading');
        if (DOMLoading && DOMLoading.style) DOMLoading.style.display = 'flex'
    }

    /**
     * 隐藏全屏 loading 提示
     */
    hidePageLoading() {
        let DOMLoading = document.querySelector('.page-loading');
        if (DOMLoading && DOMLoading.style) DOMLoading.style.display = 'none'
    }

    /**
     * SDK fireEvent webviewshow 时应该调用的逻辑
     */
    async show(res) {
        super.show(res)

        /**
         * 根据当前 webviewshow 时的时间戳更新 campaign 的 expired 标记
         * 依赖方 1: setSubPlayTemplateInfoToAllSubTpl 时需要传递 expired 给 SDK(Android 侧需要)
         * 依赖方 2: reportOnlyImpression 上报拼接 to cbt 时需要 expired 来决定上报的值
         */
        this.updateCampaignExpiredState();

        // webviewshow 时检查 SDK 传递过来的奖励信息, 如果符合要求则更新到上下文中, 并通知之前创建的两个播放模板组件设置此奖励信息
        this.setSubPlayTemplateInfoToAllSubTpl(res);

        // 检查所有 campaign 的 video 资源是否满足播放要求, 并更新对应 campaign 的 isReady 状态
        await this.updateCampaignReadyState();

        // 开始展示广告, 根据之前更新的 campaign 预加载状态 执行不同的交互逻辑
        this.startShowAd();
    }

    /**
     * 开始展示广告, 默认只展示已经 ready 的广告
     */
    startShowAd() {
        // 从 campaign 列表中筛选出 ready 的 campaign
        let readyCampaignList = this.getReadyCampaignList()
        this.readyCampaignList = readyCampaignList

        // >= 2 个 offer 的视频可以播放, 则更新对应 offer 的 ready 状态
        if (readyCampaignList.length >= 2) {
            console.warn('>= 2 个 offer 的视频可以播放')
            this.showAdSuccess({readyCampaignList})
        }

        // 如果 "只有一个 offer 的视频可以播放", 则通知 showsuccess 回调之后, 跳过二选一模板展示阶段, 直接播放视频
        else if (readyCampaignList.length === 1) {
            console.warn('"只有一个 offer 的视频可以播放"')
            this.showOneAdSuccess({readyCampaignList})
        }

            // 如果 "所有的 offer 的视频都无法播放", 则调用 SDK API 通知开发者 showfailed 回调
        // if (readyCampaignList.length <= 0)
        else {
            console.warn('所有的 offer 都没有满足 loading 条件, 无法播放视频, 调用 SDK API 通知开发者 showfailed 回调')
            this.showAdFailed({readyCampaignList})
        }
    }

    getReadyCampaignList() {
        try {
            let readyCampaignList = this.campaignList.filter(campaign => {
                let curChildTpl = this.getChildTplByCampaignId(campaign.id);
                if(campaign.isReady && curChildTpl.isImageReady){
                    return campaign
                }
            });
            return readyCampaignList
        } catch (e) {
            console.error(e)
        }
    }

    /**
     * webviewshow 时检查 SDK 传递过来的奖励信息, 如果符合要求则更新到上下文中, 并通知之前创建的两个播放模板组件
     * @param res webviewshow 时 SDK 传递过来的信息
     */
    setSubPlayTemplateInfoToAllSubTpl(res) {
        let webviewshowData = res && res.param;
        let userId = webviewshowData && webviewshowData.userId;
        let reward = webviewshowData && webviewshowData.reward;
        let defaultCampaign = this.campaignList && this.campaignList[0]
        let expired = defaultCampaign && defaultCampaign.expired;
        if (typeof expired === 'undefined') {
            console.error('获取 campaign 是否过期的标识失败, 请检查(会继续 setSubPlayTemplateInfo): ', {expired})
        }
        if (webviewshowData && typeof userId !== 'undefined' && typeof reward !== 'undefined') {
            this.updateSDKContext('userId', userId)
            this.updateSDKContext('reward', reward)
            this.childTplList.forEach(item => {
                let id = item.tplInstanceId
                let data = {userId, reward, expired}
                if (typeof id !== 'undefined') {
                    this.videoTplLegacy.setSubPlayTemplateInfo({id, data})
                } else {
                    console.error('尝试设置奖励信息时, 获取模板实例 id 失败, 请检查', {res, id})
                }
            })
        } else {
            console.warn('webviewshow 时没有从 SDK 获取到 reward userId, 无法设置奖励信息, 请检查', {res})
        }
    }

    /**
     * H5在展示大模板的时候会有一个全局的标记，表示当前展示的所有offer是否expired，
     * 发onlyImp/offer imp等的时候参考这个，并且传递给sdk campaign等时候，标记这个offer是否expired
     *
     * expired: sdk load期间预加载大模板的时候告诉H5，同isReady一样，也只能表示开始渲染的时候是否超时，
     * H5在show的时候，应该根据timestamp自己计算offer是否过期，并在传递offer给sdk的时候，修改offer维度的expired
     */
    updateCampaignExpiredState() {
        let loadSuccessTime = this.campaignList && this.campaignList[0] && this.campaignList[0].timestamp
        let plctTime = this.getFinalPlct();
        let loadExpirationTime = loadSuccessTime + plctTime
        let webviewShowTime = Date.now()
        console.log({loadSuccessTime, plctTime})
        console.log(`%c${webviewShowTime}`, 'font-family:Menlo', ' - webviewshowTime')
        console.log(`%c${loadExpirationTime}`, 'font-family:Menlo', ' - loadExpirationTime')
        console.log('webviewShowTime - loadExpirationTime: ', webviewShowTime - loadExpirationTime, ' - expired: ', webviewShowTime > loadExpirationTime)
        if (webviewShowTime > loadExpirationTime) {
            this.campaignList && this.campaignList.forEach(item => {
                item.expired = true
            })
        }
    }

    getFinalPlct() {
        let finalPlct
        let firstCampaign = this.campaignList && this.campaignList[0];
        let campaignPlct = firstCampaign && firstCampaign.plct
        let campaignAdType = firstCampaign && firstCampaign.ad_type
        let appPlct = this.appSetting && this.appSetting.plct
        let rewardPlct = this.rewardSetting && this.rewardSetting.plct
        // 优先从 offer 维度取
        if (typeof campaignPlct !== "undefined" && campaignPlct > 0) {
            console.log('尝试获取 campaignPlct: ', {campaignPlct, campaignAdType, appPlct, rewardPlct})
            finalPlct = campaignPlct
        }
        // 如果 offer 维度拿不到, 且当前是 rv/iv 则从 rewardSetting 中拿
        else if (campaignAdType === 94 || campaignAdType === 287) {
            console.log('尝试获取 rewardPlct: ', {campaignPlct, campaignAdType, appPlct, rewardPlct})
            finalPlct = rewardPlct
        }
        // 如果 当前不是 rv/iv, 则从 appSetting 维度拿
        else {
            console.log('尝试获取 appPlct: ', {campaignPlct, campaignAdType, appPlct, rewardPlct})
            finalPlct = appPlct
        }
        if (typeof finalPlct === 'undefined') {
            console.error('获取 final plct 失败, 已使用兜底的 3600')
            finalPlct = 3600
        }
        finalPlct *= 1000
        return finalPlct
    }

    // 大模板被展示, 通知 SDK 上报 only impression
    reportOnlyImpression() {
        let campaign = this.campaignList && this.campaignList[0]
        let type = campaign && campaign.imp_ua;
        let url = this.generateOnlyImpressionUrl(campaign);
        let urlsWillReport = [{type, url}]
        console.log({urlsWillReport})
        VideoBridgeReportUrls(urlsWillReport)
    }

    // 大模板被展示, 通知 SDK 上报 pv_urls
    reportPvUrls() {
        let campaign = this.campaignList && this.campaignList[0]
        let urlsWillReport = campaign && campaign.pv_urls && campaign.pv_urls.map(url => {
            return {url}
        })
        console.log({urlsWillReport})
        VideoBridgeReportUrls(urlsWillReport)
    }

    generateOnlyImpressionUrl(campaign) {
        let onlyImpressionUrl = campaign && campaign.only_impression_url;

        /**
         * TODO onlyimp 拼接字段逻辑 - 注释待补充
         */
            // to 参数初始化, 依赖 webviewshow 时更新 expired 状态: updateCampaignExpiredState
        let key_to = 'to'
        let value_to = campaign.expired ? 1 : 0
        // console.log('generateOnlyImpressionUrl: campaign.expired: ', campaign.expired)
        onlyImpressionUrl = _appendUrlParam(onlyImpressionUrl, key_to, value_to);

        // tmorl
        // ref: http://confluence.mobvista.com/pages/viewpage.action?pageId=30350188
        let key_tmorl = 'tmorl'
        let value_tmorl = this.unitSetting && this.unitSetting.tmorl || 1
        // console.log('generateOnlyImpressionUrl: this.unitSetting && this.unitSetting.tmorl: ', this.unitSetting && this.unitSetting.tmorl)
        onlyImpressionUrl = _appendUrlParam(onlyImpressionUrl, key_tmorl, value_tmorl);

        // cbt
        let key_cbt = 'cbt'
        let value_cbt
        let isHitcbp = this.unitSetting && this.unitSetting.hitcbp || 0

        // 如果超时(to=1)
        if (value_to === 1) {
            // tmorl=1, 则 cbt 上报 1
            if (value_tmorl === 1) {
                // console.log('value_tmorl === 1')
                value_cbt = 1
            }
            // tmorl=2, 则 cbt 上报 0
            else if (value_tmorl === 2) {
                // console.log('value_tmorl === 2')
                value_cbt = 0
            }
        }
        // 如果没有超时(to=0)
        else if (value_to === 0) {
            // 且是 hb 的 offer, 则不走扣回调逻辑, 始终不扣回调
            if (campaign.hb) {
                value_cbt = 0
            }
            // 如果没有超时且不是 hb 的单子, 则需要走扣回调逻辑
            else {
                value_cbt = isHitcbp
            }
        }
        onlyImpressionUrl = _appendUrlParam(onlyImpressionUrl, key_cbt, value_cbt);

        // vt
        let key_vt = 'vt'
        let value_vt
        let allLength = this.campaignList && this.campaignList.length;
        let readyLength = this.readyCampaignList && this.readyCampaignList.length;
        let isAllCampaignReady = allLength === readyLength
        if (isAllCampaignReady) {
            value_vt = 1
        } else {
            value_vt = 2
        }
        onlyImpressionUrl = _appendUrlParam(onlyImpressionUrl, key_vt, value_vt);

        // vgc int[] example: [264393623,316549139]
        let key_vgc = 'vgc'
        let value_vgc = this.readyCampaignList && this.readyCampaignList.map(campaign => campaign.id) || []
        let vgcPrefix = '[';
        let vgcSuffix = ']';
        let separator = ',';
        value_vgc = encodeURIComponent(vgcPrefix.concat(value_vgc.join(separator)).concat(vgcSuffix))
        onlyImpressionUrl = _appendUrlParam(onlyImpressionUrl, key_vgc, value_vgc);

        // mof_tplid int
        let key_mof_tplid = 'mof_tplid'
        let value_mof_tplid = this.campaignList && this.campaignList[0] && this.campaignList[0].mof_tplid
        onlyImpressionUrl = _appendUrlParam(onlyImpressionUrl, key_mof_tplid, value_mof_tplid);

        return onlyImpressionUrl;
    }

    /**
     * 注册大模板页面元素用户交互事件监听
     * @returns {Promise<void>}
     */
    registerPageHandler() {

        // 注册二选一入口的点击事件
        window.mtg_fn_showVideoTemplateLegacy = async ({currentCampaignId} = {}) => {
            console.log('window.mtg_fn_showVideoTemplateLegacy = async ({currentCampaignId} = {}) => {')
            await this.showVideoTemplateLegacyAndAutoPlay(currentCampaignId);
        }

    }

    /**
     * 根据提供的 campaign id, 播放对应的广告
     * @param currentCampaignId 要播放的 campaign
     * @returns {Promise<boolean>}
     */
    async showVideoTemplateLegacyAndAutoPlay(currentCampaignId) {
        if (typeof currentCampaignId !== 'undefined') {

            // 如果当前 campaign 没有 ready, 则停止播放, 调用开发者回调 showfailed, 并且关闭当前广告
            let matchedCampaign = this.campaignList && this.campaignList.filter(item => String(item.id) === String(currentCampaignId));
            this.currentCampaign = matchedCampaign && matchedCampaign[0]
            if (typeof this.currentCampaign === 'undefined'
                || this.currentCampaign === 'null'
                || this.currentCampaign.isReady !== true) {
                // this.showAdFailed({currentCampaignId})
                this.attemptToShowOtherVideoTemplate(currentCampaignId)
                return false
            }

            // 如果可以获取父视图 "大模板" 的实例, 则开始 addSubView
            this.userSelectedChildTpl = this.childTplList.filter(item => item.campaignId === currentCampaignId)[0]
            if (this.bigTemplateInstanceId) {
                let appendRes = await this.videoTplLegacy.append({
                    parentCmptId: this.bigTemplateInstanceId,
                    childCmptId: this.userSelectedChildTpl.tplInstanceId
                }).catch(err => {
                    console.warn({err})
                    this.attemptToShowOtherVideoTemplate(currentCampaignId)
                })
                if (checkResOK(appendRes)) {
                    _logSuccess('播放 type4 广告成功')
                } else {
                    _logError('播放 type4 广告异常, 尝试播放其他可用的广告')
                    this.attemptToShowOtherVideoTemplate(currentCampaignId)
                }
            } else {
                console.warn('大模板实例获取失败', {bigTemplateInstanceId: this.bigTemplateInstanceId})
                this.attemptToShowOtherVideoTemplate(currentCampaignId)
            }

        } else {
            console.warn('currentCampaignId 为空', {currentCampaignId})
            this.attemptToShowOtherVideoTemplate(currentCampaignId)
        }
    }

    /**
     * 检查是否所有 "子模板" 和 "大图 icon" 都已经 preload 成功
     * @returns {boolean}
     */
    allTplPreloadFinished() {
        let loadedChildTpl = this.childTplList.filter(childTpl => childTpl.isPageLoadFinished && childTpl.isImageReady);
        return loadedChildTpl.length === this.childTplList.length
    }

    /**
     * 检查是否至少有 1 个 "子模板" 和 "大图 icon" preload 成功
     * @returns {boolean}
     */
    atLeastOneTplPreloadFinished() {
        let loadedChildTpl = this.childTplList.filter(childTpl => childTpl.isPageLoadFinished && childTpl.isImageReady);
        return loadedChildTpl.length >= 1
    }

    /**
     * 调用自定义 hybrid 指令, 请确保此方法仅在开发场景中使用
     * @param fnName
     * @param params
     * @returns {Promise<void>}
     */
    async customCommand({fnName, params}) {
        return await customCommand({fnName, params})
    }

    /**
     * 对 campaign 中需要展示的部分信息进行格式化, 以满足模板展示需求
     * @param campaignList
     * @returns {any}
     */
    formatCampaignList(campaignList) {
        let campaignListTemp = JSON.parse(JSON.stringify(campaignList))
        campaignListTemp.forEach(item => {
            let rating = String(item.rating)
            item.rating = rating.indexOf('.') > -1 ? rating : (rating + '.0')
        })
        return campaignListTemp;
    }

    /**
     * webviewshow 时, 更新当前 campaign 列表所有 Video 的下载状态, 将满足播放要求的 video 所在 campaign 的 isReady 设置为 true
     * @returns {Object[]} SDK 返回的所有 video 的下载状态列表
     */
    async updateCampaignReadyState() {
        // 组装需要检查的资源列表
        let resourceWillBeChecked = this.getResourceMapWillBeChecked()
        let resourceRes = await VideoBridgeGetFileInfo({unitId: this.unitId, resource: resourceWillBeChecked})
        let resourceNewStateObjList = resourceRes && resourceRes.resource
        this.campaignList && this.campaignList.forEach((campaign = {}) => {

            if (!campaign) {
                console.error('当前要检查的 campaign 不存在')
                return false
            }

            // 如果 load 阶段 "加载大图 icon 失败" 或 "创建预加载 webview 实例失败", 则直接设置 isReady 为 false,
            // 不再检查 video 资源是否可用
            // TODO: 后续可以优化这里的逻辑, 只要 video 资源检查通过, 可以再尝试 "加载大图 icon" 和 "创建预加载 webview 实例",
            //  但因为是 webviewshow 阶段, 所以需要和产品确认创建过程中的用户交互如何处理
            //  如 "loading" 或者 "先隐藏等成功之后再挤进来", 另外要考虑创建失败的情况
            let curChildTpl = this.getChildTplByCampaignId(campaign.id)
            if (curChildTpl.isImageReady === false || typeof curChildTpl.tplInstanceId === 'undefined') {
                _logError('load 阶段 "加载大图 icon 失败" 或 "创建预加载 webview 实例失败", 不再检查 video 资源是否可用', curChildTpl)
                campaign.isReady = false
                return false
            }

            let resourceUrl, currentResourceState;
            let isPurePL = this.isCampaignPurePlayable(campaign)
            resourceUrl = isPurePL ? campaign.endcard_url : campaign.video_url;
            console.log({isPurePL, resourceUrl})
            console.log('resourceNewStateObjList.filter(item=>item[resourceUrl])', resourceNewStateObjList.filter(item => item[resourceUrl]))
            currentResourceState = resourceNewStateObjList
                && resourceNewStateObjList.filter(item => item[resourceUrl])
                && resourceNewStateObjList.filter(item => item[resourceUrl])[0]
                && resourceNewStateObjList.filter(item => item[resourceUrl])[0][resourceUrl]
            if (this.isCampaignPurePlayable(campaign)) {
                // 如果 downloaded 标识为 1, 则表示当前资源已经下载完成
                if (currentResourceState
                    && typeof currentResourceState.path === 'string'
                    && currentResourceState.path !== '') {
                    _logSuccess('当前为纯 playable, 核心资源已下载成功', {currentResourceState})
                    campaign.isReady = true
                } else {
                    _logError('当前为纯 playable, 核心资源还未下载成功', {currentResourceState})
                    campaign.isReady = false
                }
            } else {
                // 边下边播 (unitSetting.dlnet=3) 时, 不再判断 video 资源是否下载, 直接认为当前 campaign video 已经满足展示条件
                let dlnet = this.unitSetting && this.unitSetting.dlnet
                if (dlnet === 3) {
                    _logSuccess('当前为边下边播, 不再判断资源状态, 直接 ready')
                    campaign.isReady = true
                }
                // 如果 downloaded 标识为 1, 则表示当前资源已经下载完成
                else if (currentResourceState && currentResourceState.downloaded === 1) {
                    _logSuccess('当前为视频播放模板, 核心资源已下载成功', {currentResourceState})
                    campaign.isReady = true
                }
                // 如果 downloaded 标识无效, 则尝试判断下载的百分比是否满足 rate
                else {
                    let videoSize = campaign && campaign.video_size
                    let videoDataLength = currentResourceState && currentResourceState.videoDataLength;
                    let readyRate = this.getReadyRate(campaign);
                    if (videoSize > 0 && (videoDataLength / videoSize * 100) >= readyRate) {
                        _logSuccess('当前为视频播放模板, 核心资源已满足播放条件', {currentResourceState})
                        campaign.isReady = true
                    } else {
                        _logSuccess('当前为视频播放模板, 核心资源还未下载成功, 且没有满足播放条件', {currentResourceState})
                        campaign.isReady = false
                    }
                }
            }
        })
    }

    getReadyRate(campaign) {
        let readyRate = campaign && campaign.ready_rate;
        if (typeof readyRate !== 'number') {
            readyRate = this.unitSetting && this.unitSetting.ready_rate
        }
        if (typeof readyRate !== 'number') {
            readyRate = 100
        }
        return readyRate;
    }

    getResourceMapWillBeChecked() {
        return this.campaignList && this.campaignList.map(campaign => {
            let type, ref

            // 如果当前广告为纯 playable, 则只需要检查 endcard 模板资源是否存在即可
            if (this.isCampaignPurePlayable(campaign)) {
                type = 2
                ref = campaign && campaign.endcard_url
            }
            // 否则就按默认的视频播放模板, 要检查当前视频的下载情况是否满足播放条件
            else {
                type = 1
                ref = campaign && campaign.video_url
            }
            return {type, ref}
        })
    }

    isCampaignPurePlayable(campaign) {
        if (typeof campaign === "undefined") {
            console.error('当前要检查的 campaign 为空, 无法判断当前 offer 是否为纯 playable')
        }
        return campaign && campaign.playable_ads_without_video === 2;
    }

    showAdSuccess({readyCampaignList} = {}) {
        console.warn('大模板展示成功(offer * 2 success), 重新渲染大模板 UI, 发 showsuccess 回调, 上报 onlyImpression')

        console.log('---------- webviewshow 时, 重新渲染大模板静态 UI start ----------')
        // 渲染大模板静态 UI
        this.renderPageStaticUI({readyCampaignList})

        console.log('---------- 注册用户交互事件监听 start ----------')
        // 在大模板中预先初始化用户交互事件所需的 Handler
        this.registerPageHandler()

        // 大模板被展示时, 调用 SDK API 通知开发者 showsuccess 回调
        let expired = this.getCampaignExpiredState()
        callDeveloperShowSucccess({unitId: this.unitId, data: {expired}})

        // 大模板被展示, 上报通知 SDK 上报 only impression
        this.reportOnlyImpression()
        this.reportPvUrls()
    }

    getCampaignExpiredState() {
        return this.campaignList && this.campaignList[0] && this.campaignList[0].expired;
    }

    showOneAdSuccess({readyCampaignList} = {}) {
        console.warn('大模板展示被跳过(offer * 1 success), 不再渲染大模板 UI, 直接播放唯一可用的广告素材, 发 showsuccess 回调, 上报 onlyImpression')

        // webviewshow 时直接播放当前唯一可用的广告, 不再展示大模板
        let currentCampaignId = readyCampaignList[0] && readyCampaignList[0].id
        this.showVideoTemplateLegacyAndAutoPlay(currentCampaignId);

        // 大模板被展示时, 调用 SDK API 通知开发者 showsuccess 回调
        let expired = this.getCampaignExpiredState()
        callDeveloperShowSucccess({unitId: this.unitId, data: {expired}})

        // 大模板被展示, 上报通知 SDK 上报 only impression
        this.reportOnlyImpression()
    }

    async showAdFailed({readyCampaignList, currentCampaignId}) {
        console.error('大模板展示失败(offer * 0 success), 发 showfailed 回调, 并且关闭当前广告')

        let expired = this.getCampaignExpiredState()
        callDeveloperShowFailed({unitId: this.unitId, data: {expired}})

        let id = this.bigTemplateInstanceId
        await this.videoTplLegacy.close({id})
    }

    batchPreloadCampaignImageResource() {
        this.campaignList && this.campaignList.forEach(async campaign => {
            let preloadImageRes = await this.preloadCampaignImageResource(campaign)
            let currentChildTpl = this.getChildTplByCampaignId(campaign.id)
            // 如果 Promise all 返回了数组, 且长度为 2, 则认为当前 campaign 对应的大图和 icon 资源都预加载成功了
            currentChildTpl.isImageReady = preloadImageRes && preloadImageRes.length === 2;

            this.handleTplPreloadResult()
        })
    }

    preloadCampaignImageResource(campaign) {
        let imgLoadList = []
        if (campaign && typeof campaign.image_url === 'string') {
            imgLoadList.push(this.preloadImage(campaign.image_url))
        }
        if (campaign && typeof campaign.icon_url === 'string') {
            imgLoadList.push(this.preloadImage(campaign.icon_url))
        }
        return Promise.all(imgLoadList)
    }

    /**
     * 预加载图片资源
     * @param url
     * @param campaignId
     * @returns {Promise<unknown>}
     */
    preloadImage(url, campaignId) {
        let img = new Image()
        return new Promise((resolve, reject) => {
            img.onload = () => {
                resolve({code: 0, url})
            }
            img.onerror = () => {
                reject({code: 1, url})
            }
            img.src = url
        })
    }

    attemptToShowOtherVideoTemplate(currentCampaignId) {
        console.warn('尝试播放其他可用的播放模板')
        if (this.attemptCount >= this.attemptLimit) {
            console.error('尝试次数超过上限, 不再尝试, 将直接关闭广告.')
            this.showAdFailed({currentCampaignId})
        } else {
            this.attemptCount++

            let otherCampaignList = this.campaignList.filter(campaign => campaign.id !== currentCampaignId)
            let otherCampaign = otherCampaignList && otherCampaignList[0]
            this.showVideoTemplateLegacyAndAutoPlay(otherCampaign && otherCampaign.id).catch(err => {
                console.error('播放另外一个播放模板时依然出现错误, 即将关闭广告: ', err)
                this.showAdFailed({currentCampaignId})
            })
        }
    }

    getChildTplByCampaignId(campaignId) {
        try {
            return this.childTplList.filter(childTpl => childTpl.campaignId === campaignId)[0];
        } catch (e) {
            console.error(e)
        }
    }

    bindChildTplListWithCampaignList() {
        for (let i = 0; i < this.childTplList.length; i++) {
            let curChildTpl = this.childTplList[i]
            let curCampaign = this.campaignList[i];
            curChildTpl.campaignId = curCampaign.id
        }
    }

    async startCreateOtherReadyCampaign() {
        let otherReadyCampaignList = this.campaignList.filter(campaign => {
            let curChildTpl = this.getChildTplByCampaignId(campaign.id);
            if (campaign.isReady && typeof curChildTpl.tplInstanceId === 'undefined') {
                return curChildTpl
            }
        })
        for (const otherReadyCampaign of otherReadyCampaignList) {
            otherReadyCampaign.isReady = false
            await this.createVideoTemplateLegacy(otherReadyCampaign)
        }
        let otherUnloadedChildTplList = this.childTplList.filter(childTpl => {
            return typeof childTpl.tplInstanceId !== 'undefined' && childTpl.isPageLoadFinished === false
        })
        for (const otherUnloadedChildTpl of otherUnloadedChildTplList) {
            // this.addPreloadFinishEventListener(otherUnloadedChildTpl)
            await this.preloadVideoTemplateLegacy(otherUnloadedChildTpl)
        }
    }

    getCampaignByCampaignId(campaignId) {
        try {
            return this.campaignList.filter(campaign => campaign.id === campaignId)
        } catch (e) {
            console.error(e)
        }
    }
}